import React, { Fragment } from "react";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from '@headlessui/react';
import { ChevronDownIcon } from "@heroicons/react/20/solid";

function SimpleDropdown({ value, onChange, options, className = '', disabled = false }) {
  const selectedOption = options.find(option => option.value === value) || options[0];

  return (
    <div className={className}>
      <Listbox value={selectedOption} onChange={(option) => onChange(option.value)} disabled={disabled}>
        <div className="relative">
          <ListboxButton className={`relative w-full form-select ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}>
            <span className="block truncate">{selectedOption?.label}</span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </ListboxButton>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            {/* anchor switches this to Floating UI's fixed positioning and
                portals it out of the DOM flow, so it can't get clipped by an
                ancestor's overflow (e.g. DataTable's overflow-x-auto wrapper,
                which implicitly clips vertically too on a short table). */}
            <ListboxOptions
              anchor="bottom start"
              className="z-10 mt-1 max-h-60 w-[var(--button-width)] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
              {options.map((option, idx) => (
                <ListboxOption
                  key={idx}
                  className={({ active }) =>
                    `relative cursor-pointer select-none py-2 pl-4 pr-4 ${
                      active ? "bg-gray-50 text-black" : "text-gray-900"
                    }`
                  }
                  value={option}
                >
                  {({ selected }) => (
                    <>
                      <span className={`block truncate ${selected ? "font-medium" : "font-normal"}`}>
                        {option.label}
                      </span>
                      {option.description && (
                        <span className="block text-xs text-gray-500 whitespace-normal">
                          {option.description}
                        </span>
                      )}
                    </>
                  )}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}

export default SimpleDropdown;
